import { Notify } from 'vant'
import commonData from '@/commondata.js'
import request from '@/utils/request'
import ImageCompressor from 'image-compressor.js'

export function compressorImageList(list, maxWidth, maxHeight, quality, callback) {
  var num = 0
  var newList = []
  list.map((value, index, array) => {
    compressorImage(value, maxWidth, maxHeight, quality, function(data, name) {
      num++
      newList.push({ file: data, name: name })
      if (num >= list.length) {
        if (callback) {
          callback(newList)
        }
      }
    })
  })
}
export function compressorImage(file, maxWidth, maxHeight, quality, callback) {
  var u = navigator.userAgent
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  // eslint-disable-next-line no-undef
  new ImageCompressor(file, {
    checkOrientation: isIOS,
    quality: quality,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    success(result) {
      console.log('压缩图片成功', result)
      if (callback) {
        callback(result, result.name)
      }
    },
    error(e) {
      console.log('压缩图片失败', e)
      if (callback) {
        callback(file)
      }
    }
  })
}
export function MyNotify(type, body, duration) {
  // ### 正常 蓝#7ecef4  提示 灰#bfbfbf  异常 红#dd423c
  switch (type) {
    case 'error':
      Notify({
        message: body,
        duration: duration | 3000,
        background: '#dd423c'
      })
      break
    case 'info' :
      Notify({
        message: body,
        duration: duration | 2000,
        background: '#e37d19'
      })
      break
    default:
      Notify({
        message: body,
        duration: duration | 2000,
        background: '#7ecef4'
      })
  }
}

/* eslint-disable */
export function getUrlKey(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

export function formatDate(date, fmt, utcTime = false) {
    // 自动转换成时间对象
    if (!(date instanceof Date)) {
      date = new Date(date)
    }
    // 自动计算时间时区问题
    if (utcTime) {
      var utcToLoacl = new Date().getTimezoneOffset() * 60 * 1000
      var tm = date.getTime() - utcToLoacl
      date = new Date(tm)
    }
    // 格式化时间
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        const str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
      }
    }
    return fmt
  }
  
function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}
function PrefixInteger(num, length) {
  return (Array(length).join('0') + num).slice(-length)
}

export function formatTimeOfDate(time) {
  if (time >= 1440) {
    time = 1439
  }
  if (time < 60) {
    return '00:' + PrefixInteger(time, 2)
  } else {
    var h = Math.floor(time / 60)
    return PrefixInteger(h, 2) + ':' + PrefixInteger(time % 60, 2)
  }
}

export function GetEnumList(enumClassName) {
  if(commonData.enumList == undefined)
  {
    return [];
  }
  var list = commonData.enumList.find(item => item.key === enumClassName).lists
  var result = []
  for (const item of list) {
    result.push({
      text: item.value,// 'enum.' + enumClassName + '.' + item.key,
      value: item.key
    })
  }
  return result
}
export function GetEnumText(enumClassName,enumName)
{
  var list = GetEnumList(enumClassName);
  if(list.length===0)
  {
    return enumName
  }
  var item = list.find(item=>item.value === enumName);
  if(item === undefined)
  {
    return enumName;
  }
  return item.text
}

export function getLanguage(code)
{
  code = code.toLowerCase();
  return commonData.ssiBase.LANGUAGES.find(item=>item.iso3 === code);
}
export function getCountry(code)
{
  return commonData.ssiBase.COUNTRIES.find(item=>item.iso3 === code);
}

export function getLanguageText(code)
{
  if(commonData.ssiBase === undefined)
  {
    return code;
  }
  code = code.toLowerCase();
  var item = commonData.ssiBase.LANGUAGES.find(item=>item.iso3 === code);
  if(item ===undefined)
  {
    return code;
  }
  return item.name_native;
}
export function getCountryText(code)
{
  if(commonData.ssiBase === undefined)
  {
    return code;
  }
  var item = commonData.ssiBase.COUNTRIES.find(item=>item.iso3 === code);
  if(item ===undefined)
  {
    return code;
  }
  return item.country;
}

export function GetAreaNameByCode(data,code)
{
  console.log(code,data);

  return "测试";
}

export function initPage(defautltPage)
{
  if(defautltPage === undefined)
  {
    document.body.removeAttribute('class', 'whiteBody')
  }else{
    document.getElementsByTagName('body')[0].className = 'whiteBody'
  }
}


export function getCoursesList(callback)
{
  if(commonData.courseList !== undefined)
  {
    callback(commonData.courseList);
  }else{
    request({
      url: '/Course/getCoursesList',
      method: 'post'
    }).then(response => {
      commonData.courseList = response.data;
      callback(commonData.courseList)
    })
  }
}
export function randomNum(minNum,maxNum){ 
  switch(arguments.length){ 
      case 1: 
          return parseInt(Math.random()*minNum+1,10); 
      break; 
      case 2: 
          return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10); 
      break; 
          default: 
              return 0; 
          break; 
  } 
} 
///百度地图  每个尺寸级别对应 一厘米实际距离 单位米
export function baiduLevelMetre(level){
  switch(level)
  {
    case 1:return 10000*1000;
    case 2:return 5000*1000;
    case 3:return 2000*1000;
    case 4:return 1000*1000;
    case 5:return 500*1000;
    case 6:return 200*1000;
    case 7:return 100*1000;
    case 8:return 50*1000;
    case 9:return 25*1000;
    case 10:return 20*1000;
    case 11:return 10*1000;
    case 12:return 5*1000;
    case 13:return 2*1000;
    case 14:return 1000;
    case 15:return 500;
    case 16:return 200;
    case 17:return 100;
    case 18:return 50;
    case 19:return 20;
    default: return 20;
  }
}